import { useEffect, useState } from "react";
import DataTableBase from "../../common/Datatable";
import { Link } from "react-router-dom";
import makeRequest from "../../../../api";
import { trainerService } from "../../../../api/services";
import { toast } from "react-toastify";

const RolesListing = () => {
  const [rolesList, setRolesList] = useState<any>([]);

  const fetchRoles = async () => {
    try {
      const res = await makeRequest(trainerService.getTrainerRoleList());
      setRolesList([...res?.data?.body?.roles]);
    } catch (error: any) {
      toast.error("Error fetching roles list!");
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const columns = [
    {
      name: "Role name",
      selector: (row: any) => row.roleName,
      cell: (row: any) => {
        return <Link to={`${row.roleId}`}>{row.roleName}</Link>;
      },
      sortable: true,
    },
    {
      name: "Permissions",
      selector: (row: any) => row.permissions,
      cell: (row: any) => {
        return (
          <div>
            {row?.permissions
              ?.map((item: any) => item?.permissionDisplayName)
              ?.join(", ")}
          </div>
        );
      },
    },
  ];

  return (
    <div className="container-lg">
      <div className="d-flex align-items-center justify-content-between mb-4">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Roles
            </li>
          </ol>
        </nav>
        <Link to="add" className="btn btn-sm btn-outline-secondary">
          Add role
        </Link>
      </div>
      <DataTableBase columns={columns} data={rolesList} />
    </div>
  );
};

export default RolesListing;
